export const cartConfig = {
    storageLocalCartKey: 'localCart'
};
